import React from "react";
import { useParams } from "react-router-dom";
import EmotionWall from "./EmotionWall";

const SupportUserWall = () => {
  const { userId } = useParams();
  return <EmotionWall viewUserId={userId} hideComposer />;
};

export default SupportUserWall;
